export default "/images/vendor/flag-icons/flags/4x3/vi.svg?791471ab2bdc37bfc4542f37b5aff5fc";